import React from "react";
import { Button, Tooltip } from "@blueprintjs/core";
import { Icon } from "@blueprintjs/icons";
import { useTheme } from "../contexts/ThemeContext";

const ThemeToggle = () => {
  const { theme, toggleTheme, isDark } = useTheme();

  return (
    <Tooltip content={`Switch to ${isDark ? "light" : "dark"} mode`}>
      <Button
        minimal
        icon={isDark ? "flash" : "moon"}
        onClick={toggleTheme}
        style={{
          color: "var(--text-secondary)",
          transition: "color 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.target.style.color = "var(--text-primary)";
        }}
        onMouseLeave={(e) => {
          e.target.style.color = "var(--text-secondary)";
        }}
      />
    </Tooltip>
  );
};

export default ThemeToggle;
